(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcements"]) return;
  try {
    
const swiper = new Swiper('section.announcements .swiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  autoHeight: true,
  allowTouchMove: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

var announcementList = [].slice.call(document.querySelectorAll('section.announcements .swiper-slide'));
var announcementEles = announcementList.map(function (announcementEle) {

  var timerEle = announcementEle.querySelector('.banner-timer');
  if( timerEle ){
    var bannerTimerStart = (timerEle.dataset.date)?timerEle.dataset.date:new Date(Date.now() + 86400 * 1000).toISOString();
    var timeEle = timerEle.querySelector('span[banner-time]');
    /*
    TODO: Set Cookie and pull time from there to not reset on every page load 
    var targetTime = Shopify.getCookie('banner-timer')?Shopify.setCookie('banner-timer'):new Date(bannerTimerStart).getTime();
    */
    
    var targetTime = new Date(bannerTimerStart).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {
      // Get today's date and time
      var now = new Date().getTime();
      // Find the distance between now and the count down date
      var distance = targetTime - now;

      /*
      TODO: Set Cookie and pull time from there to not reset on every page load 
      Shopify.setCookie('banner-timer', distance);
      */
      
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      // Display the result in the element with id="demo"
      timeEle.innerHTML  = hours + ":" + minutes + ":" + seconds; 
  
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        timeEle.innerHTML = "EXPIRED";
      }
    }, 1000);
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('mainNavbar');
      this.headerBounds = {};
      this.currentScrollTop = 110;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if( this.header.querySelector('.navbar-toggler.show') == null )  {
        this.header.classList.remove('fixed-top', 'animate');
        this.closeMenuDisclosure();
      }
    }

    reveal() {
      this.header.classList.add('d-flex', 'fixed-top', 'animate');
      this.header.classList.remove('d-none');
    }

    reset() {
      this.header.classList.remove('fixed-top', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* show/hide canvas */
  var canvasActive = false;
  if( document.querySelector('header nav div.menu.use-offcanvas') ) {
    canvasActive = true;
    var siteOverlay = document.createElement('div');
    siteOverlay.setAttribute('id', 'siteOverlay');
    document.body.prepend(siteOverlay);
  }
  /* END show/hide canvas */

  var mainNavbar = document.getElementById('mainNavbar');
  var navToggle = mainNavbar.querySelector('button.navbar-toggler');
  
  navToggle.addEventListener('click', function(evt){

    var targetEle = evt.target.parentElement;
    if( targetEle.tagName == 'DIV' ) { targetEle = evt.target; }
    if( targetEle.tagName == 'svg' ) { targetEle = targetEle.parentElement; }
    var toggleState = targetEle.classList.toggle('show');
    targetEle.setAttribute('aria-expanded', toggleState);
    
    /* show/hide canvas */
    if( canvasActive ){
    document.body.classList.toggle('overlay-open');
    if(toggleState) { mainNavbar.querySelector('.offcanvas .offcanvas-body').focus(); }
    }
    /* END show/hide canvas */
  });
  
  var offCanvasClose = mainNavbar.querySelector('.offcanvas .offcanvas-header .btn-close');
  offCanvasClose.addEventListener('click', function(evt){
    var toggleState = navToggle.classList.toggle('show');
    navToggle.setAttribute('aria-expanded', toggleState);
    /* show/hide canvas */
    if( canvasActive ){
      document.body.classList.toggle('overlay-open');
    }
    /* END show/hide canvas */
  });

  /* move search bar on mobile */
  if( window.innerWidth < Shopify.breakpoint && window.location.pathname.indexOf('search') === -1){ 
    var searchBar = mainNavbar.querySelector('.navbar-search');
    searchBar.style.display = 'block';
    mainNavbar.querySelector('nav').append( searchBar );
  };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    
  var selectedVariantId = document.querySelector('[name="id"]').value;
  var productObj = JSON.parse(document.getElementById('ProductJson').innerHTML);
  var variantObj = getVariant( selectedVariantId );

  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  };

  function setVariant() {

    var variant = getVariant();
    var sellingPlan = getSellingPlan();

    var productContent = document.querySelector('.product-content');

    var productPrice = (sellingPlan)?sellingPlan.price:variant.price;
    var productPriceEles = [].slice.call(productContent.querySelectorAll('.product-price'));
    var productPrice = productPriceEles.map(function (ele) {
      ele.innerText = Shopify.formatMoney(productPrice);
    });

    var productCompareAtPrice = (sellingPlan)?sellingPlan.compare_at_price:variant.compare_at_price;
    var productCompareAtPriceEles = [].slice.call(productContent.querySelectorAll('.product-compare-at-price'));
    var productCompareAtPrice = productCompareAtPriceEles.map(function (ele) {
      ele.innerText = Shopify.formatMoney(productCompareAtPrice);
    });

    var sellingPlanPrice = document.querySelector('.selling-plan-price');
    if(sellingPlanPrice && sellingPlan){ sellingPlanPrice.innerText = Shopify.formatMoney(sellingPlan.price); }
    
    var oneTimePrice = document.querySelector('.price-onetime');
    if(oneTimePrice){ oneTimePrice.innerText = Shopify.formatMoney(variant.price); }
    
    /*
    var descriptionSwap = productContent.getElementById('product_body_box').dataset.descriptionSwap;

    if( descriptionSwap.length > 0 ) {
      var variantDescription = htmlDecode(descriptionSwap[variant.id]);
      if( variantDescription && variantDescription.length > 0 ) {
        productContent.getElementById('product_body_box').innerHTML = variant_description;
      };
    };
    */

    /* If variant isnt available, show as sold out w/o notify ability */
    if(!variant.available) { 
      //alert("That combination isn't available. Choose another option.");
      if( document.querySelector('.klaviyo-bis-trigger') ){
        document.querySelector('.klaviyo-bis-trigger').style.display = 'block';
      };
    } else {
      if( document.querySelector('.klaviyo-bis-trigger') ){
        document.querySelector('.klaviyo-bis-trigger').style.display = 'none';
      };
    }

    var querystring = new URLSearchParams(window.location.search)
    querystring.set('variant', variant.id);
    querystring.set('selling_plan', (sellingPlan)?sellingPlan.selling_plan_id:'');
    querystring = '?' + querystring.toString();
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + querystring;
    window.history.replaceState({path: newurl}, '', newurl);

    updateFloatingAtc();

  };

  function getVariant( variantId=false ) {
    var currentVariant = (variantObj)?variantObj:false;
    if( !variantId ) { variantId = document.querySelector('form input[name="id"]').value; }
    if( currentVariant && currentVariant.id == variantId ) {
      return variantObj;
    } else {
      var variants = productObj.variants;
      var variant = variants.find(({ id }) => id === Number(variantId));
      return variant;
    };
  };

  function getSellingPlan( sellingPlanId=false ) {
    var variant = getVariant();
    if( !sellingPlanId ) { sellingPlanId = document.querySelector('form input[name="selling_plan"]').value; }
    if( !sellingPlanId ) { return false; }
    var sellingPlan = variant.selling_plan_allocations.find(({ selling_plan_id }) => selling_plan_id === Number(sellingPlanId));
    return sellingPlan;
  };

  var sellingPlanGroups = [].slice.call(document.querySelectorAll('input[name="selling_plan_group"]'));
  var sellingPlanGroup = sellingPlanGroups.map(function (sellingPlanEle) {
    sellingPlanEle.addEventListener('change', function(evt){

      var currentActiveGroup = document.querySelector('.selling-plan-fieldset .form-check.active');
      if( currentActiveGroup ) { document.querySelector('.selling-plan-fieldset .form-check.active').classList.remove('active'); }
      evt.target.parentElement.classList.add('active');
      
      var sellingPlanSelector = evt.target.parentElement.querySelector('[name="selling_plan_choice"]');
      var sellingPlanId = (sellingPlanSelector)?sellingPlanSelector.value:'';
      document.querySelector('form input[name="selling_plan"]').value = sellingPlanId;
    
      setVariant();
    });
  });

  var sellingPlanChoices = [].slice.call(document.querySelectorAll('[name="selling_plan_choice"]'));
  var sellingPlanChoice = sellingPlanChoices.map(function (sellingPlanChoiceEle) {
    sellingPlanChoiceEle.addEventListener('change', function(evt){
      document.querySelector('form input[name="selling_plan"]').value = evt.target.value;
      setVariant();
    });
  });

  var variantSelector = document.querySelector('variant-select');
  if( variantSelector ){
    variantSelector.addEventListener('change', function(evt){
      document.querySelector('form input[name="id"]').value = evt.target.value;
    });
  };

  var optionChoices = [].slice.call(document.querySelectorAll('.product-options .option-group input'));
  var optionChoice = optionChoices.map(function (optionEle) {
    optionEle.addEventListener('change', function(evt){

      /* loop through all available options and get currently selected value */
      var selected_options = [];
      productObj.options.forEach(async function(option) {
        if( document.querySelector('[data-option="'+option+'"] input') ) {
          selected_options.push( document.querySelector('[data-option="'+option+'"] input:checked').value );
        } else if(document.querySelector('[data-option="'+option+'"] select') ) {
          selected_options.push( document.querySelector('[data-option="'+option+'"] select').value );
        }
      });
  
      /* find variant by selected value(s) */
      var selected_variant = productObj.variants.find(function(variant, index) {
        if(selected_options.length == 3 && variant.option1 == selected_options[0] && variant.option2 == selected_options[1] && variant.option3 == selected_options[2] ) {
          return true;
        } else if(selected_options.length == 2 && variant.option1 == selected_options[0] && variant.option2 == selected_options[1] ) {
          return true;
        } else if(selected_options.length == 1 && variant.option1 == selected_options[0]) {
          return true;
        } else {
          return false;
        }
      });

      document.querySelector('form input[name="id"]').value = selected_variant.id;
      setVariant();

    });
  });

  var floatingAtc = document.querySelector('.floating-atc');
  
  function updateFloatingAtc(){
    var floatingAtcForm = document.getElementById('floatingAtcForm');
    var floatingAtcButton = document.querySelector('.floating-atc button');
    var primaryForm = document.getElementById('AddToCartForm');
    var buyButton = document.querySelector('.product-actions button[type="submit"]');

    floatingAtcForm.querySelector('input[name="id"]').value = primaryForm.querySelector('input[name="id"]').value;
    floatingAtcForm.querySelector('input[name="selling_plan"]').value = primaryForm.querySelector('input[name="selling_plan"]').value;
    floatingAtcForm.querySelector('input[name="quantity"]').value = primaryForm.querySelector('[name="quantity"]').value;
    floatingAtcButton.innerHTML = buyButton.innerHTML;
  };

  if( floatingAtc && window.innerWidth < Shopify.breakpoint ){

    var offsetTarget = 1550;
    window.addEventListener('scroll', function() {
      if (window.pageYOffset >= offsetTarget) {
        floatingAtc.style.display = 'block';
      } else {
        floatingAtc.style.display = 'none';
      };
    });
  
    if (window.pageYOffset >= offsetTarget) {
      floatingAtc.style.display = 'block';
    } else {
      floatingAtc.style.display = 'none';
    };
    
  }; /* if( floatingAtc ) */

  const mipThumbsSwiper = new Swiper('.mip-thumbs.swiper', {
    // Optional parameters
    direction: 'horizontal',
    spaceBetween: 10,
    slidesPerView: 5,
    watchSlidesProgress: true,
    breakpoints: {
      992: {
        direction: 'vertical',
      }
    }
  });
  
  const mipHeroSwiper = new Swiper('.mip-hero.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    autoHeight: true,
    allowTouchMove: true,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: mipThumbsSwiper,
    }
  });

  /* Move Buy Badges ondesktop */
  var buyBadges = document.querySelector('.product-buy-badges');
  if( buyBadges && window.innerWidth > 992 ) { document.querySelector('.product-header .product-media').append(buyBadges); }

  setVariant();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendations);

      const url = productRecommendations.querySelector('.product-grid').dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.recommended-products');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }
		MiniCart.bindUIActions();
      })
      .catch(e => {
        console.error(e);
      });

    };

    const productRecommendations = document.querySelector('.recommended-products');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendations);


  } catch(e) { console.error(e); }
})();
})();
